import * as types from '../actions/types';
const initialState = {
    globalVariables: [],
    filterVariables: [],
    searchText: "",
    searchType: "",
    variableCreateDetails: {},
    variableUpdateDetails: {},
    alertMsg: '',
    alertType: '',
    totalVariableRecords: 0,
    variableDropDownList: [],
};
const globalVariable = function (state = initialState, action) {

    switch (action.type) {

        case types.FETCH_GLOBAL_VARIABLE_LIST:
            return Object.assign({}, state, {
                globalVariables: action.payload.variables,
                filterVariables: action.payload.variables,
                totalVariableRecords: action.payload.totalVariableRecords,

            });
        case types.FETCH_VARIABLE_DROPDOWN_LIST:
            return Object.assign({}, state, {
                variableDropDownList: action.payload.variableDropDownList,
            });
        case types.FILTER_GLOBAL_VARIABLE_LIST:
            return Object.assign({}, state, {
                filterVariables: action.payload.variables,
                searchText: action.payload.searchText,
                searchType: action.payload.searchType,
            });
        case types.CREATE_GLOBAL_VARIABLE:
            return Object.assign({}, state, {
                variableCreateDetails: action.payload.variableData,
            });
        case types.UPDATE_GLOBAL_VARIABLE:
            return Object.assign({}, state, {
                variableUpdateDetails: action.payload.variableData,
            });
        case types.FETCH_ALERT_MESSAGE:
            return Object.assign({}, state, {
                alertMsg: action.payload.alertMsg,
                alertType: action.payload.alertType,

            });
        default:
            return state;
    }
}

export default globalVariable;
